import React, { useEffect, useState } from "react";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ScientificCommitteeTable from "../../Pages/Manager/ScientificCommitteeTable";

function ScientificCommittee() {
  const [taskId, settaskId] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <SharedDiv
        showTitle={true}
        titleName="طلبات اللجنة العلمية "
        child={[
          <>
            <ScientificCommitteeTable taskId={taskId} />
          </>,
        ]}
      />
    </>
  );
}

export default ScientificCommittee;
